import React, { useState, useEffect } from 'react'
import { Grid, Link as MaterialLink } from '@mui/material'
import Stateseal from '../assets/images/dta.png'
import massHealth from '../assets/images/masshealth_brand_750x374.png'
import PhoneCall from '@mui/icons-material/PhoneRounded'
import { getLanguage, showFeedBack } from '../store/actions/languageActions'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import config from 'config/config'

const Footer = ({ onGetLanguage, langDetails, feedBack }) => {
  const [footer, setFooter] = useState(langDetails?.constantStrings)
  useEffect(() => {
    onGetLanguage(localStorage.getItem('language'))
  }, [JSON.stringify(localStorage.getItem('language'))])
  useEffect(() => {
    setFooter(langDetails?.constantStrings)
  }, [langDetails])
  // const pathname = window.location.pathname
  // const clickFeedBack = () => {
  //   feedBack(true)
  // }
  return (
    <>
      <Grid container direction={{ xs: 'row', md: 'row-reverse', lg: 'row-reverse' }} role="contentinfo">
        <Grid container item xs={12} md={7} lg={7} justifyContent="flex-end">

        <Grid item xs={12} md={12} lg={12} className="font-18 footer-list" aria-label='navigation'>
            <div>
              <PhoneCall fontSize="medium" className="footerIcons" id="phoneIcon" />
              <a href="tel:1-800-841-2900" aria-label="phone number">
                (800) 841-2900
              </a>
            </div>
            <div>
              <MaterialLink href={config?.navUrls?.contactUs} onClick={(e) => { e.preventDefault(); window.open(config?.navUrls?.contactUs) }} aria-label="contact">
                {footer?.contactUs}
              </MaterialLink>
            </div>
            <div>
              <MaterialLink href={config?.navUrls?.sitePolicies} onClick={(e) => { e.preventDefault(); window.open(config?.navUrls?.sitePolicies) }} aria-label='site policies'>
                {footer?.sitePolicies}
              </MaterialLink>
            </div>
            <div>
              <MaterialLink href={config?.navUrls?.accessibility} onClick={(e) => { e.preventDefault(); window.open(config?.navUrls?.accessibility) }} aria-label='accessibility'>
                {footer?.accessibility}
              </MaterialLink>
            </div>
            {/* {(pathname !== '/home' && pathname !== '/landing') && (
              <div>
              <MaterialLink component={Link} to='/feedback' aria-label='feedback'>
                {footer?.feedback}
              </MaterialLink>
            </div>
            )}
            {(pathname === '/landing') && (
              <div>
              <MaterialLink component={Link} to='/feedBackLanding' aria-label='feedBack'>
                {footer?.feedback}
              </MaterialLink>
            </div>
            )}
            {(pathname === '/home') && (
              <div>
              <MaterialLink component={Link} onClick={clickFeedBack} aria-label='feedback'>
                {footer?.feedback}
              </MaterialLink>
            </div>
            )} */}
          </Grid>
          <Grid item xs={12} md={12} lg={12} sx={{ m: 0, p: 0, pb: 4 }} textAlign={{ xs: 'left', md: 'left', lg: 'left' }} >
            <p style={{ margin: '0px', lineHeight: 1.25 }}>{footer?.missionStatement}</p>
          </Grid>
          <Grid item xs={12} md={12} lg={12} sx={{ m: 0, p: 0, pb: 2 }} textAlign={{ xs: 'left', md: 'left', lg: 'left' }} >
            <span>&#169; {new Date().getFullYear()}{footer?.commonWealthMassachusetts}</span>
          </Grid>
        </Grid>
        <Grid item xs={12} md={5} lg={5} justifyContent="flex-start" className="footer-logo">
          <Grid container item xs={12} md={12} lg={12} sx={{ pt: 2, pb: 2 }} textAlign={{ xs: 'left', md: 'left', lg: 'left' }} display="flex" spacing={0} >
            <MaterialLink href={config?.navUrls?.massHealthTopics} onClick={(e) => { e.preventDefault(); window.open(config?.navUrls?.massHealthTopics) }} >
              <img className="footer-lg-img" src={massHealth} alt="MassHealth logo" />
            </MaterialLink>
            <MaterialLink href={config?.navUrls?.dtaConnectUrl} onClick={(e) => { e.preventDefault(); window.open(config?.navUrls?.dtaConnectUrl) }}>
              <img className="footer-lg-img" src={Stateseal} alt="DTA Connect Logo" />
            </MaterialLink>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

const mapStateToProps = (state) => ({ langDetails: state.language, feedBackFlag: state.flag })

const mapDispatchToProps = (dispatch) => {
  return {
    onGetLanguage: (lang) => dispatch(getLanguage(lang)),
    feedBack: (flag) => dispatch(showFeedBack(flag))
  }
}

Footer.propTypes = {
  onGetLanguage: PropTypes.func,
  langDetails: PropTypes.object,
  feedBackFlag: PropTypes.object,
  feedBack: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(Footer)
